/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
// eslint-disable-next-line no-unused-vars
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// eslint-disable-next-line no-unused-vars
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
// eslint-disable-next-line no-unused-vars
import { FaEdit } from "react-icons/fa";
// eslint-disable-next-line no-unused-vars
import { FiSave } from "react-icons/fi";
import { TiFlash } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from "recharts";
import { AGENCIAS_DIRECTAS } from "../../constants/permisos";
import { useAuthContext } from "../../context/auth";
import {
  getIntermediarios,
  updateCliente,
  getOportunidades,
  getContratos,
  getCategorias,
  getSubcategorias,
  getUsers,
  getClientes,
  updateOportunidad,
  updateContrato,
  getOportunidadesBTL,
  fetchAllActividadesBulk,
  buildContactMap,
  supabase,
} from "../../utils";
import { getRateForOpp, getImporteEnUSD } from "../../utils/calculateVentas";
import { getLocale } from "../../utils/getLocale";
import { getOportunidadDateStatus } from "../../utils/oportunidadDateStatus";
import { useExchangeRates } from "../../utils/useExchangeRates";
import { CategoriaSubcategoriaFilter } from "../CategoriaSubcategoriaFilter";
import { FlashEditModal } from "../FlashEditModal";
import { ActividadesRecientes } from "./components/ActividadesRecientes";
import styles from "./VentasMiListaClientesV2.module.scss";

export const VentasMiListaClientesV2 = ({ renderHeader, filterStyles }) => {
  const s = filterStyles || styles;
  const [clientes, setClientesPublicitarios] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [loading, setLoading] = useState(true);
  // OCULTO TEMPORALMENTE: Estados para edición de contactos (reactivar con columnas EDIT y PRÓXIMO CONTACTO)
  /* eslint-disable no-unused-vars */
  const [, setEditingClienteId] = useState(null);
  const [editingClienteContact, setEditingClienteContact] = useState(null);
  const [editingAgenciaContact, setEditingAgenciaContact] = useState(null);
  const [ultimo_contacto_fecha_cliente, setUltimoContactoFechaCliente] = useState(null);
  const [ultimo_contacto_accion_cliente, setUltimoContactoAccionCliente] = useState("");
  const [proximo_contacto_fecha_cliente, setProximoContactoFechaCliente] = useState(null);
  const [proximo_contacto_accion_cliente, setProximoContactoAccionCliente] = useState("");
  const [ultimo_contacto_fecha_agencia, setUltimoContactoFechaAgencia] = useState(null);
  const [ultimo_contacto_accion_agencia, setUltimoContactoAccionAgencia] = useState("");
  const [proximo_contacto_fecha_agencia, setProximoContactoFechaAgencia] = useState(null);
  const [proximo_contacto_accion_agencia, setProximoContactoAccionAgencia] = useState("");
  /* eslint-enable no-unused-vars */
  const [todasLasOportunidades, setTodasLasOportunidades] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroMes, setFiltroMes] = useState([]);
  const [filtroEstatus, setFiltroEstatus] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroSubcategoria, setFiltroSubcategoria] = useState("");
  const [subcategorias, setSubcategorias] = useState([]);
  const [sumasFiltradas, setSumasFiltradas] = useState({
    "100%": 0,
    "90%": 0,
    "75%": 0,
    "50%": 0,
    "0%": 0,
  });
  const [sumCierres, setSumCierres] = useState(0);
  const [usuarios, setUsuarios] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [ordenamiento] = useState({ porFecha: "null" });
  const [data, setData] = useState([
    {
      name: "Total",
      "100%": 0,
      "90%": 0,
      "75%": 0,
      "50%": 0,
      "0%": 0,
      empty: 100,
    },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [tipoCliente, setTipoCliente] = useState("");
  const [filtroCategoriaCliente, setFiltroCategoriaCliente] = useState([]);
  const [filtroProducto, setFiltroProducto] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState(null);
  const [selectedOportunidadId, setSelectedOportunidadId] = useState(null);
  const [flashEditingOpportunity, setFlashEditingOpportunity] = useState(null);
  const [isFlashEditing, setIsFlashEditing] = useState(false);
  const [flashSaving, setFlashSaving] = useState(false);
  const [filtroUsuario, setFiltroUsuario] = useState("");
  const [todasLasOportunidadesBTL, setTodasLasOportunidadesBTL] = useState([]);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [actividadesCRM, setActividadesCRM] = useState({}); // { clienteId: [actividades] }
  const [loadingCRM, setLoadingCRM] = useState(true);
  const [ventasData, setVentasData] = useState({
    ventasPorCliente: {},
    ventasYTD: {},
    ventasAA: {}, // Año Anterior (2025)
    ventasHTD: {},
    oportunidades90: {},
    oportunidades75: {},
    oportunidades50: {},
  });
  const getCurrentYear = () => new Date().getFullYear().toString();
  const CURRENT_YEAR = getCurrentYear(); // "2026"
  const { pais, rol, id } = useAuthContext() || {};

  const { getDolarValue, dolarFallback, loaded: ratesLoaded } = useExchangeRates(pais);
  const fallbackRate = dolarFallback?.[pais] || 1;

  const [viewInUSD, setViewInUSD] = useState(false);

  const navigate = useNavigate();

  // react-hook-form ya no se usa, Flash modal maneja su propio estado

  const clientesMemo = useMemo(() => clientes, [clientes]);

  const todasLasOportunidadesMemo = useMemo(() => todasLasOportunidades, [todasLasOportunidades]);

  const todasLasOportunidadesBTLMemo = useMemo(() => todasLasOportunidadesBTL, [todasLasOportunidadesBTL]);

  const clienteCategoriaMap = useMemo(() => {
    const map = {};
    clientes.forEach((cliente) => {
      if (cliente.categoria == null) {
        map[cliente.id] = "";
        return;
      }
      const categoria = categorias.find(
        (cat) => cat?.id != null && cat.id.toString() === cliente.categoria.toString()
      );
      map[cliente.id] = categoria ? categoria.nombre : "";
    });
    return map;
  }, [clientes, categorias]);

  // Conversión USD → moneda local con rate histórico por fecha de la opp.
  // Si moneda_dolar=false, retorna el importe sin tocar.
  const getConvertedImporte = useCallback(
    (oportunidad) => {
      const importe = oportunidad.importe || 0;
      if (!oportunidad.moneda_dolar) return importe;
      const rate = getRateForOpp(oportunidad, getDolarValue, fallbackRate);
      return importe * rate;
    },
    [getDolarValue, fallbackRate]
  );

  const getConvertedImporteBTL = useCallback(
    (oportunidadBTL) => {
      const importe = oportunidadBTL.total_investment || 0;
      if (!oportunidadBTL.moneda_dolar) return importe;
      const rate = getRateForOpp(oportunidadBTL, getDolarValue, fallbackRate);
      return importe * rate;
    },
    [getDolarValue, fallbackRate]
  );

  const normalizeMonth = (month, createdAt, ano = null) => {
    if (!month || typeof month !== "string") {
      if (ano) return `01-${ano}`;
      return null;
    }
    if (/^\d{2}-\d{4}$/.test(month)) return month;
    const monthNum = parseInt(month, 10);
    if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && ano) {
      return `${monthNum.toString().padStart(2, "0")}-${ano}`;
    }
    return null;
  };

  const calculateSalesSums = (oportunidades, oportunidadesBTL, year, startMonth = 1, endMonth = 12, pais, inUSD = false) => {
    const filterAndSum = (ops, status, field, includeMin = false, isBTL = false) => {
      const filteredOps = ops.filter((op) => {
        const useField = op[field] ? field : op.estatus === "100%" && !isBTL ? "mes_cierre" : null;
        if (!useField || !op[useField]) {
          return false;
        }
        const [month, ano] = op[useField].split("-").map(Number);
        const estatus = isBTL ? (op.status === 100 ? "100%" : `${op.status || 0}%`) : op.estatus;
        return estatus === status &&
          !op.eliminada &&
          ano === parseInt(year) &&
          month >= startMonth &&
          month <= endMonth &&
          op.pais === pais
          ? true
          : false;
      });
      const groups = {};
      filteredOps.forEach((op) => {
        const key = op.client_id;
        if (!groups[key]) groups[key] = [];
        const importe = inUSD
          ? getImporteEnUSD(op, getDolarValue, fallbackRate)
          : isBTL
            ? getConvertedImporteBTL(op)
            : getConvertedImporte(op);
        groups[key].push(importe);
      });
      let total = 0;
      for (const key in groups) {
        const importes = groups[key];
        total +=
          includeMin && importes.length > 1 ? Math.min(...importes) : importes.reduce((sum, val) => sum + val, 0);
      }
      return total;
    };
    const sumCierresRegular = filterAndSum(oportunidades, "100%", "mes_cierre", false, false);
    const sumCierresBTL = filterAndSum(oportunidadesBTL, "100%", "mes_cierre", false, true);
    const sumaImportes100Regular = filterAndSum(oportunidades, "100%", "mes_factura", false, false);
    const sumaImportes100BTL = filterAndSum(oportunidadesBTL, "100%", "mes_factura", false, true);
    const sumaImportes90 = filterAndSum(oportunidades, "90%", "mes_cierre", true, false);
    const sumaImportes75 = filterAndSum(oportunidades, "75%", "mes_cierre", true, false);
    const sumaImportes50 = filterAndSum(oportunidades, "50%", "mes_cierre", true, false);
    const sumaImportes0 = filterAndSum(oportunidades, "0%", "mes_cierre", true, false);
    return {
      sumCierres: sumCierresRegular + sumCierresBTL,
      sumaImportes100: sumaImportes100Regular + sumaImportes100BTL,
      sumaImportes90,
      sumaImportes75,
      sumaImportes50,
      sumaImportes0,
    };
  };

  const calculateVentasYOportunidades = (oportunidades, oportunidadesBTL, clientes, currentYear = CURRENT_YEAR, inUSD = false) => {
    const ventasPorCliente = {};
    const ventasYTD = {}; // Ventas que se facturarán en el año actual
    const ventasAA = {}; // Ventas del año anterior (2025)
    const ventasHTD = {}; // Ventas facturadas en años anteriores (excluyendo año actual y AA)
    const previousYear = String(Number(currentYear) - 1); // 2025

    // Helper para obtener el año de facturación
    const getFacturaYear = (op) => {
      // Prioridad 1: facturafecha
      if (op.facturafecha) {
        const facturaDate = new Date(op.facturafecha);
        if (!isNaN(facturaDate.getTime())) {
          return String(facturaDate.getFullYear());
        }
      }
      // Prioridad 2: mes_factura (formato "MM-YYYY")
      if (op.mes_factura) {
        const parts = op.mes_factura.split("-");
        if (parts.length === 2) {
          return parts[1];
        }
      }
      return null;
    };

    // Procesar oportunidades publicitarias
    oportunidades.forEach((op) => {
      const estatus = op.estatus ? op.estatus.trim() : "0%";
      if (!op.eliminada && op.pais === pais && estatus === "100%") {
        const clientId = op.client_id;
        const importe = inUSD
          ? getImporteEnUSD(op, getDolarValue, fallbackRate)
          : getConvertedImporte(op);

        // Determinar el año de FACTURACIÓN (no de cierre)
        const facturaYear = getFacturaYear(op);

        // Total general (mantener compatibilidad)
        if (!ventasPorCliente[clientId]) ventasPorCliente[clientId] = 0;
        ventasPorCliente[clientId] += importe;

        // YTD: Facturación del año actual
        if (facturaYear === currentYear) {
          if (!ventasYTD[clientId]) ventasYTD[clientId] = 0;
          ventasYTD[clientId] += importe;
        }

        // AA: Facturación del año anterior (2025)
        if (facturaYear === previousYear) {
          if (!ventasAA[clientId]) ventasAA[clientId] = 0;
          ventasAA[clientId] += importe;
        }

        // HTD: Suma histórica de TODOS los años excepto el actual (incluye AA)
        if (facturaYear && facturaYear !== currentYear) {
          if (!ventasHTD[clientId]) ventasHTD[clientId] = 0;
          ventasHTD[clientId] += importe;
        }
      }
    });

    // Procesar oportunidades BTL
    oportunidadesBTL.forEach((opBTL) => {
      const estatus = opBTL.estatus ? opBTL.estatus.trim() : opBTL.status ? `${opBTL.status}%` : "0%";
      if (!opBTL.eliminada && opBTL.pais === pais && (estatus === "100%" || opBTL.status === 100)) {
        const clientId = opBTL.client_id;
        const importe = inUSD
          ? getImporteEnUSD(opBTL, getDolarValue, fallbackRate)
          : getConvertedImporteBTL(opBTL);

        // Determinar el año de FACTURACIÓN (no de cierre)
        const facturaYear = getFacturaYear(opBTL);

        // Total general
        if (!ventasPorCliente[clientId]) ventasPorCliente[clientId] = 0;
        ventasPorCliente[clientId] += importe;

        // YTD: Facturación del año actual
        if (facturaYear === currentYear) {
          if (!ventasYTD[clientId]) ventasYTD[clientId] = 0;
          ventasYTD[clientId] += importe;
        }

        // AA: Facturación del año anterior (2025)
        if (facturaYear === previousYear) {
          if (!ventasAA[clientId]) ventasAA[clientId] = 0;
          ventasAA[clientId] += importe;
        }

        // HTD: Suma histórica de TODOS los años excepto el actual (incluye AA)
        if (facturaYear && facturaYear !== currentYear) {
          if (!ventasHTD[clientId]) ventasHTD[clientId] = 0;
          ventasHTD[clientId] += importe;
        }
      }
    });

    return [ventasPorCliente, ventasYTD, ventasAA, ventasHTD];
  };

  const getIntermediarioNombre = useCallback(
    (intermediarioValue) => {
      if (typeof intermediarioValue === "string" && !/^\d+$/.test(intermediarioValue)) return intermediarioValue;
      const intermediario = intermediarios.find(
        (inter) => String(inter.id) === String(intermediarioValue) && inter.pais === pais
      );
      return intermediario ? intermediario.nombre : "";
    },
    [intermediarios, pais]
  );

  const sortContacts = (contactIds, usuarios, type, priorityRoles) => {
    const validContacts = contactIds
      .filter((id) => id && usuarios.find((user) => String(user.id) === String(id)))
      .map((id) => usuarios.find((user) => String(user.id) === String(id)))
      .sort((a, b) => {
        const roleA = a.rol ? a.rol.toLowerCase().trim() : "";
        const roleB = b.rol ? b.rol.toLowerCase().trim() : "";
        const priorityA = priorityRoles.indexOf(roleA);
        const priorityB = priorityRoles.indexOf(roleB);
        if (priorityA !== priorityB) return priorityA - priorityB;
        return `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`);
      });
    return validContacts;
  };

  const filtrarOportunidades = useCallback(
    () =>
      todasLasOportunidadesMemo.filter((oportunidad) => {
        const nombreIntermediario = getIntermediarioNombre(oportunidad.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteMatch = clientesMemo.find((c) => c.id === oportunidad.client_id);
        const clienteCategoria = clienteMatch ? clienteMatch.categoria : null;
        const clienteNombre = clienteMatch ? clienteMatch.empresa.toLowerCase() : "";
        const clienteProducto = clienteMatch ? clienteMatch.producto : "";
        const matchesEjecutivo =
          !filtroEjecutivo ||
          clienteMatch?.ejecutivos_asignados?.includes(Number(filtroEjecutivo)) ||
          String(clienteMatch?.ejecutivo) === String(filtroEjecutivo);

        // Para filtro de mes: prioridad 1 = facturafecha, prioridad 2 = mes_factura
        let mesFacturaStr = null;
        if (oportunidad.facturafecha) {
          const facturaDate = new Date(oportunidad.facturafecha);
          if (!isNaN(facturaDate.getTime())) {
            mesFacturaStr = String(facturaDate.getMonth() + 1).padStart(2, "0");
          }
        }
        if (!mesFacturaStr && oportunidad.mes_factura) {
          mesFacturaStr = oportunidad.mes_factura.split("-")[0] || null;
        }

        return (
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesFacturaStr && filtroMes.includes(mesFacturaStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(oportunidad.estatus || "0%")) &&
          matchesIntermediario &&
          (filtroCategoria === "" || (clienteCategoria && parseInt(clienteCategoria) === parseInt(filtroCategoria))) &&
          matchesEjecutivo
        );
      }),
    [
      todasLasOportunidadesMemo,
      clientesMemo,
      filtroCliente,
      filtroProducto,
      filtroMes,
      filtroEstatus,
      filtroIntermediario,
      filtroCategoria,
      filtroEjecutivo,
      getIntermediarioNombre,
    ]
  );

  const filtrarOportunidadesMemo = useMemo(() => filtrarOportunidades(), [filtrarOportunidades]);
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const getPaisCode = (countryName) => {
    switch (countryName.toLowerCase()) {
      case "Uruguay":
        return "URU";
      case "Chile":
        return "CHI";
      case "Perú":
        return "PER";
      default:
        return countryName;
    }
  };
  const toUpperCase = (text) => text?.toString().toUpperCase();

  // Convierte importe a la moneda usada para ordenar/comparar.
  // Si viewInUSD=true → todos los importes a USD (rate histórico).
  // Si viewInUSD=false → todos a moneda local (rate histórico, pero el callsite pasa op completa).
  // Nota: para sortear basta con que ambos lados estén en la misma moneda; usamos USD siempre.
  const convertirParaSort = useCallback(
    (op) => getImporteEnUSD(op, getDolarValue, fallbackRate),
    [getDolarValue, fallbackRate]
  );

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes) - 1] || "";
  }, []);

  const getMonedaSymbol = useCallback(() => {
    const symbols = {
      Chile: "$",
      Perú: "S/",
      Uruguay: "$",
    };
    return symbols[pais] || "$";
  }, [pais]);

  const formatMoneda = useCallback(
    (valor, monedaDolar = false) => {
      if (valor === null || valor === undefined || isNaN(valor)) return "-";

      const simbolo = monedaDolar ? "US$" : getMonedaSymbol();

      // Decimales: USD 0, Chile local 0, Perú local 2.
      const decimals = monedaDolar ? 0 : pais === "Perú" ? 2 : 0;

      const formatted = Number(valor).toLocaleString(getLocale(pais), {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });

      return `${simbolo} ${formatted}`;
    },
    [pais, getMonedaSymbol]
  );
  const renderProductosOptions = () => {
    const productosFiltrados = filtroCliente
      ? clientes.filter((c) => c.empresa === filtroCliente).map((c) => c.producto)
      : [];
    const productosOrdenados = [...new Set(productosFiltrados)].sort();
    return productosOrdenados.map((producto, index) => (
      <option key={index} value={producto || ""}>
        {producto || "Sin producto"}
      </option>
    ));
  };
  const renderUsuariosOptions = () => {
    const usuariosUnicos = [
      ...new Set(
        clientes
          .flatMap((cliente) => [
            cliente.contacto_cliente,
            cliente.contacto_cliente_1,
            cliente.contacto_cliente_2,
            cliente.contacto_cliente_3,
            cliente.contacto_agencia,
            cliente.contacto_agencia_1,
            cliente.contacto_agencia_2,
            cliente.contacto_agencia_3,
          ])
          .filter((id) => id && usuarios.find((user) => String(user.id) === String(id)))
          .map((id) => usuarios.find((user) => String(user.id) === String(id)))
          .map((user) => user.id)
      ),
    ]
      .map((id) => {
        const user = usuarios.find((user) => String(user.id) === String(id));
        const clienteAsociado = clientes.find(
          (cliente) =>
            cliente.contacto_cliente === id ||
            cliente.contacto_cliente_1 === id ||
            cliente.contacto_cliente_2 === id ||
            cliente.contacto_cliente_3 === id
        );
        const agenciaAsociada = clientes.find(
          (cliente) =>
            cliente.contacto_agencia === id ||
            cliente.contacto_agencia_1 === id ||
            cliente.contacto_agencia_2 === id ||
            cliente.contacto_agencia_3 === id
        );
        let nombreAsociado = "";
        if (clienteAsociado) {
          nombreAsociado = clienteAsociado.empresa;
        } else if (agenciaAsociada) {
          nombreAsociado = getIntermediarioNombre(agenciaAsociada.agencia);
        }
        return {
          id,
          nombre: `${user.nombre} ${user.apellido}${nombreAsociado ? `, ${nombreAsociado}` : ""}`,
        };
      })
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
    return usuariosUnicos.map((usuario, index) => (
      <option key={index} value={usuario.id}>
        {usuario.nombre}
      </option>
    ));
  };
  const getProductosCount = (empresa) => {
    const filteredClientes = clientes.filter((c) => c.empresa === empresa);
    return [...new Set(filteredClientes.map((c) => c.producto))].length;
  };
  const isEditableByDate = (createdAt) => {
    const cutoffDate = new Date("2025-04-19");
    const createdDate = new Date(createdAt);
    if (isNaN(createdDate)) return false;
    return createdDate >= cutoffDate;
  };
  const getDaysDifference = (dateString, isFuture = false) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("-").map(Number);
    const targetDate = new Date(year, month - 1, day);
    if (isNaN(targetDate.getTime())) return "-";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffTime = targetDate - today;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    if (isFuture) {
      if (diffDays < 0) return "Contactar!";
      if (diffDays === 0) return "Hoy";
      if (diffDays === 1) return "Mañana";
      const todayDayOfWeek = today.getDay();
      const daysUntilSunday = todayDayOfWeek === 0 ? 0 : 7 - todayDayOfWeek;
      const endOfCurrentWeek = new Date(today);
      endOfCurrentWeek.setDate(today.getDate() + daysUntilSunday);
      const startOfNextWeek = new Date(endOfCurrentWeek);
      startOfNextWeek.setDate(endOfCurrentWeek.getDate() + 1);
      const endOfNextWeek = new Date(startOfNextWeek);
      endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
      if (targetDate >= today && targetDate <= endOfCurrentWeek) return "Esta semana";
      if (targetDate >= startOfNextWeek && targetDate <= endOfNextWeek) return "Próxima semana";
      return "15 días o más";
    } else {
      if (diffDays === 0) return "Hoy";
      if (diffDays === -1) return "Ayer";
      const todayDayOfWeek = today.getDay();
      const startOfCurrentWeek = new Date(today);
      startOfCurrentWeek.setDate(today.getDate() - (todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1));
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      if (targetDate >= startOfCurrentWeek && targetDate <= yesterday) return "Esta semana";
      const startOfLastWeek = new Date(startOfCurrentWeek);
      startOfLastWeek.setDate(startOfCurrentWeek.getDate() - 7);
      const endOfLastWeek = new Date(startOfLastWeek);
      endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
      const startOfTwoWeeksAgo = new Date(startOfLastWeek);
      startOfTwoWeeksAgo.setDate(startOfLastWeek.getDate() - 7);
      const endOfTwoWeeksAgo = new Date(startOfTwoWeeksAgo);
      endOfTwoWeeksAgo.setDate(startOfTwoWeeksAgo.getDate() + 6);
      if (targetDate >= startOfTwoWeeksAgo && targetDate <= endOfTwoWeeksAgo) return "Hace 2 semanas";
      if (targetDate >= startOfLastWeek && targetDate <= endOfLastWeek) return "Semana pasada";
      if (diffDays < -14) return "15 días o más";
      return "-";
    }
  };
  // eslint-disable-next-line no-unused-vars
  const getStatusFromText = (text, isFuture = false) => {
    if (!text || text === "-") return "default";
    const normalizedText = text.toLowerCase();
    if (isFuture) {
      if (normalizedText.startsWith("contactar!")) return "expired";
      if (normalizedText === "hoy" || normalizedText === "mañana") return "todayTomorrow";
      if (normalizedText === "esta semana") return "thisWeek";
      if (normalizedText === "próxima semana") return "nextWeek";
      if (normalizedText === "15 días o más") return "later";
    }
    return "default";
  };
  const handleMesChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMes(selectedMonths);
  }, []);
  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`mes${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtroMes.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={handleMesChange}
          style={{ marginLeft: "-35px" }}
        />
        <label className="form-check-label" htmlFor={`mes${index}`} style={{ marginLeft: "0px" }}>
          {mes}
        </label>
      </div>
    ));
  const renderClientesOptions = () => {
    const clientesOrdenados = [...new Set(clientes.map((cliente) => cliente.empresa))].sort();
    return clientesOrdenados.map((empresa, index) => (
      <option key={index} value={empresa}>
        {empresa}
      </option>
    ));
  };
  const renderIntermediariosOptions = () => {
    const intermediariosFiltrados = intermediarios.filter((intermediario) => intermediario.pais === pais);
    const nombresIndividuales = [...new Set(intermediariosFiltrados.map((intermediario) => intermediario.nombre))];
    const padresUnicos = [
      ...new Set(
        nombresIndividuales.filter((nombre) => nombre.includes("|")).map((nombre) => nombre.split("|")[0].trim())
      ),
    ];
    const todasLasOpciones = [...padresUnicos, ...nombresIndividuales];
    const opcionesUnicasOrdenadas = [...new Set(todasLasOpciones)].sort();
    return opcionesUnicasOrdenadas.map((opcion, index) => (
      <option key={index} value={opcion}>
        {opcion}
      </option>
    ));
  };
  const renderCategoriaClienteOptions = () =>
    ["A", "B", "C"].map((categoria, index) => (
      <div key={index} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`categoriaCliente${categoria}`}
          value={categoria}
          checked={filtroCategoriaCliente.includes(categoria)}
          onChange={handleCategoriaClienteChange}
          style={{ marginLeft: "-35px" }}
        />
        <label className="form-check-label" htmlFor={`categoriaCliente${categoria}`} style={{ marginLeft: "0px" }}>
          {categoria}
        </label>
      </div>
    ));
  const handleCategoriaClienteChange = (e) => {
    const categoria = e.target.value;
    setFiltroCategoriaCliente((prev) =>
      prev.includes(categoria) ? prev.filter((c) => c !== categoria) : [...prev, categoria]
    );
  };
  const handleEstatusChange = (e) => {
    const value = e.target.value;
    setFiltroEstatus((prev) => (prev.includes(value) ? prev.filter((estatus) => estatus !== value) : [...prev, value]));
  };
  const handleFlashEdit = (oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id);
    if (!cliente) {
      toast.error("No se encontró el cliente asociado a esta oportunidad.");
      return;
    }
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" &&
        !(cliente.ejecutivos_asignados?.includes(Number(id)) || String(id) === String(oportunidad.ejecutivo)))
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    setFlashEditingOpportunity({ ...oportunidad, clienteNombre: cliente.nombre });
    setIsFlashEditing(true);
  };
  const onSubmitFlashEdit = async (updatedFields) => {
    try {
      setFlashSaving(true);
      await (flashEditingOpportunity.esContrato
        ? updateContrato({ id: flashEditingOpportunity.id, contrato: updatedFields })
        : updateOportunidad({ id: flashEditingOpportunity.id, oportunidad: updatedFields }));
      toast.success(
        flashEditingOpportunity.esContrato ? "Contrato actualizado correctamente" : "Oportunidad actualizada correctamente"
      );
      const updatedOportunidades = todasLasOportunidades.map((op) =>
        op.id === flashEditingOpportunity.id ? { ...op, ...updatedFields } : op
      );
      setTodasLasOportunidades(updatedOportunidades);
      const clienteMatch = clientes.find((c) => c.id === flashEditingOpportunity.client_id);
      if (clienteMatch) {
        const updatedClientes = clientes.map((cliente) =>
          cliente.id === flashEditingOpportunity.client_id ? { ...cliente, ...updatedFields } : cliente
        );
        setClientesPublicitarios(updatedClientes);
        const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
          updatedOportunidades,
          todasLasOportunidadesBTL,
          updatedClientes,
          CURRENT_YEAR,
          viewInUSD
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: newVentasCliente,
          ventasYTD: newVentasYTD,
          ventasAA: newVentasAA,
          ventasHTD: newVentasHTD,
        }));
      }
      setIsFlashEditing(false);
      setFlashEditingOpportunity(null);
    } catch (error) {
      console.error("Error updating oportunidad:", error);
      toast.error("Error al actualizar la oportunidad");
    } finally {
      setFlashSaving(false);
    }
  };
  const handleEdit = (oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id);
    if (!cliente) {
      toast.error("No se encontró el cliente asociado a esta oportunidad.");
      return;
    }
    if (
      oportunidad.facturanumero ||
      oportunidad.estatus === "0%" ||
      (pais === "Chile" &&
        !(cliente.ejecutivos_asignados?.includes(Number(id)) || String(id) === String(oportunidad.ejecutivo)))
    ) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    if (pais === "Perú" || pais === "Chile") {
      if (isEditableByDate(oportunidad.created_at)) {
        navigate(`/admin/online-cotizador/editar/${oportunidad.id}`, { state: { oportunidad } });
      } else {
        setSelectedClienteId(oportunidad.client_id);
        setSelectedOportunidadId(oportunidad.id);
        setIsModalOpen(true);
      }
    } else {
      console.warn("Edición no soportada para el país:", pais);
      toast.info("Edición no disponible para este país.");
    }
  };
  const renderEstatusOptions = () =>
    ["100%", "90%", "75%", "50%", "0%", "sinPropuesta"].map((estatus, index) => (
      <div key={index} className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`estatus${index}`}
          value={estatus}
          checked={filtroEstatus.includes(estatus)}
          onChange={handleEstatusChange}
          style={{ marginLeft: "-35px" }}
        />
        <label className="form-check-label" htmlFor={`estatus${index}`} style={{ marginLeft: "0px" }}>
          {estatus === "sinPropuesta" ? "Sin Propuesta" : estatus}
        </label>
      </div>
    ));
  // OCULTO TEMPORALMENTE: Función para actualizar cliente (reactivar con columnas EDIT)
  // eslint-disable-next-line no-unused-vars
  const handleUpdateCliente = async (
    clienteId,
    newEjecutivo, // Este parámetro ya no se usará
    newAgencia,
    ultimoFechaCliente,
    ultimoAccionCliente,
    proximoFechaCliente,
    proximoAccionCliente,
    ultimoFechaAgencia,
    ultimoAccionAgencia,
    proximoFechaAgencia,
    proximoAccionAgencia,
    newContactoClienteId,
    newContactoAgenciaId,
    newTipo
  ) => {
    try {
      const cliente = clientes.find((c) => c.id === clienteId);
      if (!cliente) throw new Error("Cliente no encontrado");
      const updatedData = { id: clienteId };

      // Actualizar solo si hay cambios en las fechas o acciones de contacto
      if (
        ultimoFechaCliente !== null ||
        ultimoAccionCliente !== null ||
        proximoFechaCliente !== null ||
        proximoAccionCliente !== null
      ) {
        updatedData.ultimo_contacto_fecha_cliente =
          ultimoFechaCliente instanceof Date
            ? ultimoFechaCliente.toISOString().split("T")[0]
            : ultimoFechaCliente || cliente.ultimo_contacto_fecha_cliente;
        updatedData.ultimo_contacto_accion_cliente = ultimoAccionCliente || cliente.ultimo_contacto_accion_cliente;
        updatedData.proximo_contacto_fecha_cliente =
          proximoFechaCliente instanceof Date
            ? proximoFechaCliente.toISOString().split("T")[0]
            : proximoFechaCliente || cliente.proximo_contacto_fecha_cliente;
        updatedData.proximo_contacto_accion_cliente = proximoAccionCliente || cliente.proximo_contacto_accion_cliente;
      }
      if (
        ultimoFechaAgencia !== null ||
        ultimoAccionAgencia !== null ||
        proximoFechaAgencia !== null ||
        proximoAccionAgencia !== null
      ) {
        updatedData.ultimo_contacto_fecha_agencia =
          ultimoFechaAgencia instanceof Date
            ? ultimoFechaAgencia.toISOString().split("T")[0]
            : ultimoFechaAgencia || cliente.ultimo_contacto_fecha_agencia;
        updatedData.ultimo_contacto_accion_agencia = ultimoAccionAgencia || cliente.ultimo_contacto_accion_agencia;
        updatedData.proximo_contacto_fecha_agencia =
          proximoFechaAgencia instanceof Date
            ? proximoFechaAgencia.toISOString().split("T")[0]
            : proximoFechaAgencia || cliente.proximo_contacto_fecha_agencia;
        updatedData.proximo_contacto_accion_agencia = proximoAccionAgencia || cliente.proximo_contacto_accion_agencia;
      }

      // Actualizar otros campos solo si se proporcionan, sin tocar ejecutivo ni ejecutivos_asignados
      if (newAgencia !== undefined && newAgencia !== null) updatedData.agencia = newAgencia;
      if (newContactoClienteId !== null) {
        updatedData.contactoId = newContactoClienteId;
        updatedData.contacto_cliente = newContactoClienteId;
      }
      if (newContactoAgenciaId !== null) updatedData.contacto_agencia = newContactoAgenciaId;
      if (newTipo !== "" && newTipo !== null) updatedData.categoria_cliente = newTipo;

      // Auto-detectar agencia si hay contacto agencia pero intermediario es DIRECTO o null
      const contactoAgFinal = updatedData.contacto_agencia ?? cliente.contacto_agencia;
      if (contactoAgFinal) {
        const agenciaActual = updatedData.agencia ?? cliente.agencia;
        const intermObj = intermediarios.find((i) => i.id === agenciaActual);
        const esDirectoONull = !agenciaActual || (intermObj?.nombre || "").toUpperCase() === "DIRECTO";
        if (esDirectoONull) {
          const usuarioContacto = usuarios.find((u) => u.id === contactoAgFinal);
          if (usuarioContacto?.agencia) {
            const intermDetectado = intermediarios.find((i) => i.id === usuarioContacto.agencia);
            if (intermDetectado) {
              updatedData.agencia = usuarioContacto.agencia;
              toast.success(`Intermediario actualizado a "${intermDetectado.nombre}" (detectado del contacto asignado)`);
            }
          }
        }
      }

      await updateCliente(updatedData);
      // Sincronizar contacto_agencia a tabla relacional (fuente de la verdad)
      if (newContactoAgenciaId !== null) {
        try {
          await supabase.removeWhere("clientes_contactos_agencia", `cliente_id=eq.${clienteId}`);
          if (newContactoAgenciaId) {
            const agCargos = [
              { uid: newContactoAgenciaId, cargo: "Director" },
              { uid: cliente.contacto_agencia_1, cargo: "Supervisor" },
              { uid: cliente.contacto_agencia_2, cargo: "Planificador" },
              { uid: cliente.contacto_agencia_3, cargo: "Asistente" },
            ].filter((r) => r.uid);
            await supabase.insert(
              "clientes_contactos_agencia",
              agCargos.map((r) => ({ cliente_id: clienteId, usuario_id: r.uid, cargo: r.cargo }))
            );
          }
        } catch (e) {
          console.error("Error sincronizando contactos agencia relacional:", e);
        }
      }
      // Sincronizar contacto_cliente a tabla relacional (fuente de la verdad)
      if (newContactoClienteId !== null) {
        try {
          await supabase.removeWhere("clientes_contactos_cliente", `cliente_id=eq.${clienteId}`);
          if (newContactoClienteId) {
            const clCargos = [
              { uid: newContactoClienteId, cargo: "Gerente de Marketing" },
              { uid: cliente.contacto_cliente_1, cargo: "Jefe de Medios" },
              { uid: cliente.contacto_cliente_2, cargo: "Supervisor" },
              { uid: cliente.contacto_cliente_3, cargo: "Asistente" },
            ].filter((r) => r.uid);
            await supabase.insert(
              "clientes_contactos_cliente",
              clCargos.map((r) => ({ cliente_id: clienteId, usuario_id: r.uid, cargo: r.cargo }))
            );
          }
        } catch (e) {
          console.error("Error sincronizando contactos cliente relacional:", e);
        }
      }
      setClientesPublicitarios(
        clientes.map((cliente) => (cliente.id === clienteId ? { ...cliente, ...updatedData } : cliente))
      );
      setEditingClienteId(null);
      setEditingClienteContact(null);
      setEditingAgenciaContact(null);
      setUltimoContactoFechaCliente(null);
      setUltimoContactoAccionCliente("");
      setProximoContactoFechaCliente(null);
      setProximoContactoAccionCliente("");
      setUltimoContactoFechaAgencia(null);
      setUltimoContactoAccionAgencia("");
      setProximoContactoFechaAgencia(null);
      setProximoContactoAccionAgencia("");
      setTipoCliente("");
      toast.success("Datos guardados exitosamente");
    } catch (error) {
      console.error("Error updating cliente:", error.message);
      toast.error("Error al guardar los datos: " + error.message);
    }
  };
  const handleUpdateStatus = async (clienteId, oportunidadId, newStatus) => {
    try {
      const allowedStatuses = ["100%", "90%", "75%", "50%", "0%"];
      if (!allowedStatuses.includes(newStatus)) throw new Error("Estatus no válido");
      const oportunidad = todasLasOportunidades.find((op) => op.id === oportunidadId);
      if (!oportunidad) throw new Error("No se encontró la oportunidad para el cliente seleccionado");
      const currentYear = new Date().getFullYear().toString();
      const updateData = {
        estatus: newStatus,
        updated_at: new Date().toISOString(),
        mes_cierre:
          oportunidad.mes_cierre || `${(new Date().getMonth() + 1).toString().padStart(2, "0")}-${currentYear}`,
        mes_factura:
          oportunidad.mes_factura || `${(new Date().getMonth() + 1).toString().padStart(2, "0")}-${currentYear}`,
        ano: oportunidad.mes_factura ? parseInt(oportunidad.mes_factura.split("-")[1], 10) : parseInt(currentYear, 10),
      };
      const response = await updateOportunidad({ id: oportunidadId, oportunidad: updateData });
      if (!response || response.error || response.length === 0)
        throw new Error(response.error?.message || "No se pudo actualizar la oportunidad");
      const updatedOportunidades = todasLasOportunidades.map((op) =>
        op.id === oportunidadId ? { ...op, ...updateData } : op
      );
      setTodasLasOportunidades(updatedOportunidades);
      const clienteMatch = clientes.find((c) => c.id === clienteId);
      if (clienteMatch) {
        const updatedClientes = clientes.map((cliente) =>
          cliente.id === clienteId ? { ...cliente, ...updateData } : cliente
        );
        setClientesPublicitarios(updatedClientes);
        const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
          updatedOportunidades,
          todasLasOportunidadesBTL,
          updatedClientes,
          CURRENT_YEAR,
          viewInUSD
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: newVentasCliente,
          ventasYTD: newVentasYTD,
          ventasAA: newVentasAA,
          ventasHTD: newVentasHTD,
        }));
      }
      toast.success("Estatus actualizado exitosamente");
    } catch (error) {
      console.error("Error al actualizar el estatus:", error.message);
      toast.error("Error al actualizar el estatus: " + error.message);
    }
  };

  const calcularSumasFiltradas = useCallback(
    debounce(() => {
      // Filtrar oportunidades basadas en facturafecha o mes_factura para facturación
      const filteredOportunidadesFact = filtrarOportunidadesMemo.filter((op) => {
        // Incluir si tiene facturafecha O mes_factura (igual que calcularPublicidadMensual)
        if (!op.facturafecha && !op.mes_factura) return false;
        return true;
      });
      const filteredOportunidadesBTLFact = todasLasOportunidadesBTLMemo.filter((btl) => {
        if (!btl.facturafecha && !btl.mes_factura) return false; // Incluir si tiene facturafecha O mes_factura
        const cliente = clientesMemo.find((c) => c.id === btl.client_id);
        const nombreIntermediario = getIntermediarioNombre(btl.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteNombre = cliente ? cliente.empresa.toLowerCase() : "";
        const clienteProducto = cliente ? cliente.producto : "";
        const mesFacturaStr = btl.mes_factura?.split("-")?.[0] || null;
        const estatus = btl.status === 100 ? "100%" : `${btl.status || 0}%`;
        return (
          btl.pais === pais &&
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesFacturaStr && filtroMes.includes(mesFacturaStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(estatus)) &&
          matchesIntermediario &&
          (!filtroCategoria || (cliente && clienteCategoriaMap[btl.client_id] === filtroCategoria)) &&
          (!filtroEjecutivo || (btl.ejecutivo != null && String(btl.ejecutivo) === filtroEjecutivo))
        );
      });

      // Filtrar oportunidades basadas en mes_cierre para cierres (sin depender del filtro mes_factura)
      const filteredOportunidadesCierre = todasLasOportunidadesMemo.filter((oportunidad) => {
        if (!oportunidad.mes_cierre) return false;
        const nombreIntermediario = getIntermediarioNombre(oportunidad.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteMatch = clientesMemo.find((c) => c.id === oportunidad.client_id);
        const clienteCategoria = clienteMatch ? clienteMatch.categoria : null;
        const clienteNombre = clienteMatch ? clienteMatch.empresa.toLowerCase() : "";
        const clienteProducto = clienteMatch ? clienteMatch.producto : "";
        const matchesEjecutivo =
          !filtroEjecutivo ||
          clienteMatch?.ejecutivos_asignados?.includes(Number(filtroEjecutivo)) ||
          String(clienteMatch?.ejecutivo) === String(filtroEjecutivo);
        // Para cierres, filtrar por mes_cierre (no mes_factura)
        const mesCierreStr = oportunidad.mes_cierre?.split("-")?.[0] || null;
        return (
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesCierreStr && filtroMes.includes(mesCierreStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(oportunidad.estatus || "0%")) &&
          matchesIntermediario &&
          (filtroCategoria === "" || (clienteCategoria && parseInt(clienteCategoria) === parseInt(filtroCategoria))) &&
          matchesEjecutivo
        );
      });
      const filteredOportunidadesBTLCierre = todasLasOportunidadesBTLMemo.filter((btl) => {
        if (!btl.mes_cierre) return false;
        const cliente = clientesMemo.find((c) => c.id === btl.client_id);
        const nombreIntermediario = getIntermediarioNombre(btl.intermediario);
        const matchesIntermediario =
          filtroIntermediario === "" ||
          nombreIntermediario === filtroIntermediario ||
          (!filtroIntermediario.includes("|") && nombreIntermediario.startsWith(`${filtroIntermediario} |`));
        const clienteNombre = cliente ? cliente.empresa.toLowerCase() : "";
        const clienteProducto = cliente ? cliente.producto : "";
        const estatus = btl.status === 100 ? "100%" : `${btl.status || 0}%`;
        // Para cierres BTL, filtrar por mes_cierre (no mes_factura)
        const mesCierreStr = btl.mes_cierre?.split("-")?.[0] || null;
        return (
          btl.pais === pais &&
          (!filtroCliente || clienteNombre.includes(filtroCliente.toLowerCase())) &&
          (!filtroProducto || clienteProducto === filtroProducto) &&
          (filtroMes.length === 0 || (mesCierreStr && filtroMes.includes(mesCierreStr))) &&
          (filtroEstatus.length === 0 || filtroEstatus.includes(estatus)) &&
          matchesIntermediario &&
          (!filtroCategoria || (cliente && clienteCategoriaMap[btl.client_id] === filtroCategoria)) &&
          (!filtroEjecutivo || (btl.ejecutivo != null && String(btl.ejecutivo) === filtroEjecutivo))
        );
      });

      // Calcular sumas con los datos filtrados
      const { sumCierres } = calculateSalesSums(
        filteredOportunidadesCierre,
        filteredOportunidadesBTLCierre,
        CURRENT_YEAR,
        1,
        12,
        pais,
        viewInUSD
      );

      const { sumaImportes100, sumaImportes90, sumaImportes75, sumaImportes50, sumaImportes0 } = calculateSalesSums(
        filteredOportunidadesFact,
        filteredOportunidadesBTLFact,
        CURRENT_YEAR,
        1,
        12,
        pais,
        viewInUSD
      );

      setSumasFiltradas({
        "100%": sumaImportes100,
        "90%": sumaImportes90,
        "75%": sumaImportes75,
        "50%": sumaImportes50,
        "0%": sumaImportes0,
      });
      setSumCierres(sumCierres);

      // Actualizar ventasPorCliente con calculateVentasYOportunidades
      const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
        filteredOportunidadesFact,
        filteredOportunidadesBTLFact,
        clientesMemo,
        CURRENT_YEAR,
        viewInUSD
      );
      setVentasData((prev) => ({
        ...prev,
        ventasPorCliente: newVentasCliente,
        ventasYTD: newVentasYTD,
        ventasAA: newVentasAA,
        ventasHTD: newVentasHTD,
      }));
    }, 300),
    [
      filtrarOportunidadesMemo,
      todasLasOportunidadesMemo,
      todasLasOportunidadesBTLMemo,
      filtroCliente,
      filtroProducto,
      filtroMes,
      filtroEstatus,
      filtroIntermediario,
      filtroCategoria,
      filtroEjecutivo,
      getIntermediarioNombre,
      pais,
      clientesMemo,
      clienteCategoriaMap,
      categorias,
      viewInUSD,
      ratesLoaded,
    ]
  );

  useEffect(() => {
    calcularSumasFiltradas();
  }, [calcularSumasFiltradas]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const paisCode = getPaisCode(pais);
        const [
          categoriasData,
          clientesData,
          intermediariosData,
          oportunidadesData,
          usuariosData,
          oportunidadesBTLData,
          contratosRaw,
          subcategoriasData,
          ccaData,
        ] = await Promise.all([
          getCategorias(),
          getClientes({ pais: paisCode, orderBy: "nombre", ascending: true }),
          getIntermediarios({ pais: paisCode }),
          getOportunidades({ pais: paisCode }),
          getUsers(),
          getOportunidadesBTL({ pais: paisCode }),
          getContratos({ pais }),
          getSubcategorias(),
          supabase.select("clientes_contactos_agencia").catch(() => []),
        ]);
        // Enriquecer clientes con contactos de agencia desde tabla relacional
        const ccaMap = {};
        (ccaData || []).forEach((r) => {
          if (!ccaMap[r.cliente_id]) ccaMap[r.cliente_id] = [];
          ccaMap[r.cliente_id].push(r);
        });
        clientesData.forEach((cli) => {
          const rels = ccaMap[cli.id] || [];
          if (rels.length > 0) {
            cli.contacto_agencia = rels[0]?.usuario_id || null;
            cli.contacto_agencia_1 = rels[1]?.usuario_id || null;
            cli.contacto_agencia_2 = rels[2]?.usuario_id || null;
            cli.contacto_agencia_3 = rels[3]?.usuario_id || null;
          }
        });
        // Normalizar igual que VentasProyeccion
        const oportunidadesNoEliminadas = oportunidadesData
          .filter((oportunidad) => !oportunidad.eliminada)
          .map((oportunidad) => ({
            ...oportunidad,
            mes_cierre: normalizeMonth(oportunidad.mes_cierre, oportunidad.created_at, oportunidad.ano),
            mes_factura: normalizeMonth(oportunidad.mes_factura, oportunidad.created_at, oportunidad.ano),
          }));
        // Normalizar contratos (sales_contratos) para mergear con oportunidades
        const contratosNormalizados = (contratosRaw || [])
          .filter((c) => !c.eliminada && c.pais === pais)
          .map((c) => ({
            ...c,
            importe: Number(c.importe_total) || 0,
            esContrato: true,
            mes_cierre: normalizeMonth(c.mes_cierre, c.created_at, c.ano),
            mes_factura: c.meses?.[0]?.mes
              ? normalizeMonth(c.meses[0].mes, c.created_at, c.ano)
              : null,
            facturafecha: c.meses?.[0]?.facturafecha || null,
          }));
        setTodasLasOportunidades([...oportunidadesNoEliminadas, ...contratosNormalizados]);
        const oportunidadesBTLNoEliminadas = oportunidadesBTLData
          .filter((btl) => !btl.eliminada && btl.pais === pais)
          .map((btl) => ({
            ...btl,
            mes_cierre: normalizeMonth(btl.mes_cierre, btl.created_at, btl.ano),
            mes_factura: normalizeMonth(btl.mes_factura, btl.created_at, btl.ano),
          }));
        setTodasLasOportunidadesBTL(oportunidadesBTLNoEliminadas);
        setCategorias(categoriasData);
        setSubcategorias(subcategoriasData || []);
        const filteredClientes = clientesData;
        // viewInUSD se aplica en el useEffect dependiente de filtrarOportunidadesMemo
        const [ventasCliente, ventasYTD, ventasAA, ventasHTD] = calculateVentasYOportunidades(
          oportunidadesNoEliminadas,
          oportunidadesBTLNoEliminadas,
          filteredClientes,
          CURRENT_YEAR
        );
        setVentasData((prev) => ({
          ...prev,
          ventasPorCliente: ventasCliente,
          ventasYTD: ventasYTD,
          ventasAA: ventasAA,
          ventasHTD: ventasHTD,
        }));
        setClientesPublicitarios(filteredClientes);
        setIntermediarios(intermediariosData);
        setUsuarios(usuariosData);
        setLoading(false);
      } catch (error) {
        console.error("Error al inicializar datos:", error);
        toast.error("Hubo un error al cargar los datos. Inténtalo de nuevo.");
        setLoading(false);
      }
    };
    fetchData();
  }, [pais]);

  // Cargar actividades CRM en bulk, priorizando clientes con oportunidades
  useEffect(() => {
    let cancelled = false;

    const cargarActividadesCRM = async () => {
      if (clientes.length === 0 || usuarios.length === 0) return;
      setLoadingCRM(true);

      try {
        const paisCode = getPaisCode(pais);
        const contactMap = buildContactMap(clientes, usuarios);
        const allClienteIds = clientes.map((c) => c.id);

        // Determinar clientes con oportunidades (aparecen primero en la tabla)
        const clientesConOportunidades = new Set();
        [...todasLasOportunidades, ...todasLasOportunidadesBTL].forEach((op) => {
          if (op.client_id && allClienteIds.includes(op.client_id)) {
            clientesConOportunidades.add(op.client_id);
          }
        });

        const priorityIds = allClienteIds.filter((id) => clientesConOportunidades.has(id));
        const restIds = allClienteIds.filter((id) => !clientesConOportunidades.has(id));

        // Oleada 1: clientes con oportunidades (top de la tabla)
        let actividadesPorCliente = {};
        if (priorityIds.length > 0) {
          const priorityContactMap = {};
          priorityIds.forEach((id) => {
            priorityContactMap[id] = contactMap[id];
          });
          actividadesPorCliente = await fetchAllActividadesBulk(paisCode, priorityIds, priorityContactMap, 50);
          if (!cancelled) {
            setActividadesCRM({ ...actividadesPorCliente });
            setLoadingCRM(false);
          }
        }

        // Oleada 2: clientes sin oportunidades
        if (restIds.length > 0 && !cancelled) {
          const restContactMap = {};
          restIds.forEach((id) => {
            restContactMap[id] = contactMap[id];
          });
          const restActividades = await fetchAllActividadesBulk(paisCode, restIds, restContactMap, 50);
          actividadesPorCliente = { ...actividadesPorCliente, ...restActividades };
          if (!cancelled) setActividadesCRM(actividadesPorCliente);
        }

        // Rellenar clientes sin actividades con array vacío
        allClienteIds.forEach((id) => {
          if (!actividadesPorCliente[id]) actividadesPorCliente[id] = [];
        });
        if (!cancelled) setActividadesCRM(actividadesPorCliente);
      } catch (error) {
        log.error("cargarActividadesCRM", error);
        if (!cancelled) {
          const emptyResult = {};
          clientes.forEach((c) => {
            emptyResult[c.id] = [];
          });
          setActividadesCRM(emptyResult);
        }
      } finally {
        if (!cancelled) setLoadingCRM(false);
      }
    };

    cargarActividadesCRM();
    return () => {
      cancelled = true;
    };
  }, [clientes, usuarios, todasLasOportunidades, todasLasOportunidadesBTL, pais]);

  useEffect(() => {
    calcularSumasFiltradas();
  }, [calcularSumasFiltradas]);

  useEffect(() => {
    const [newVentasCliente, newVentasYTD, newVentasAA, newVentasHTD] = calculateVentasYOportunidades(
      filtrarOportunidadesMemo,
      todasLasOportunidadesBTLMemo,
      clientesMemo,
      CURRENT_YEAR,
      viewInUSD
    );
    setVentasData((prev) => ({
      ...prev,
      ventasPorCliente: newVentasCliente,
      ventasYTD: newVentasYTD,
      ventasAA: newVentasAA,
      ventasHTD: newVentasHTD,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrarOportunidadesMemo, todasLasOportunidadesBTLMemo, clientesMemo, viewInUSD, ratesLoaded]);

  const getContactoPriority = (
    cliente,
    today,
    todayDate,
    tomorrowDate,
    startOfCurrentWeek,
    endOfCurrentWeek,
    startOfNextWeek,
    endOfNextWeek,
    fifteenDaysFromNow
  ) => {
    const proximoContactoCliente = parseLocalDate(cliente.proximo_contacto_fecha_cliente);
    const proximoContactoAgencia = parseLocalDate(cliente.proximo_contacto_fecha_agencia);
    let proximoContactoDate = proximoContactoCliente;
    if (proximoContactoAgencia && (!proximoContactoCliente || proximoContactoAgencia < proximoContactoCliente)) {
      proximoContactoDate = proximoContactoAgencia;
    } else if (!proximoContactoCliente && !proximoContactoAgencia) return 999;
    if (!proximoContactoDate || isNaN(proximoContactoDate.getTime())) return 999;
    if (proximoContactoDate < today) return 1;
    if (
      proximoContactoDate.getFullYear() === todayDate.getFullYear() &&
      proximoContactoDate.getMonth() === todayDate.getMonth() &&
      proximoContactoDate.getDate() === todayDate.getDate()
    )
      return 2;
    if (
      proximoContactoDate.getFullYear() === tomorrowDate.getFullYear() &&
      proximoContactoDate.getMonth() === tomorrowDate.getMonth() &&
      proximoContactoDate.getDate() === tomorrowDate.getDate()
    )
      return 3;
    if (
      proximoContactoDate >= startOfCurrentWeek &&
      proximoContactoDate <= endOfCurrentWeek &&
      proximoContactoDate >= today
    )
      return 4;
    if (proximoContactoDate >= startOfNextWeek && proximoContactoDate <= endOfNextWeek) return 5;
    if (proximoContactoDate >= fifteenDaysFromNow) return 6;
    return 7;
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayDate = new Date(today);
  const tomorrowDate = new Date(today);
  tomorrowDate.setDate(today.getDate() + 1);
  const todayDayOfWeek = today.getDay();
  const startOfCurrentWeek = new Date(today);
  startOfCurrentWeek.setDate(today.getDate() - (todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1));
  const endOfCurrentWeek = new Date(startOfCurrentWeek);
  endOfCurrentWeek.setDate(startOfCurrentWeek.getDate() + 6);
  const startOfNextWeek = new Date(startOfCurrentWeek);
  startOfNextWeek.setDate(startOfCurrentWeek.getDate() + 7);
  const endOfNextWeek = new Date(startOfNextWeek);
  endOfNextWeek.setDate(startOfNextWeek.getDate() + 6);
  const fifteenDaysFromNow = new Date(today);
  fifteenDaysFromNow.setDate(today.getDate() + 15);
  const mapOrdenamientoToText = (value) =>
    ({
      contactar: "Contactar!",
      hoy: "Hoy",
      mañana: "Mañana",
      estaSemana: "Esta semana",
      proximaSemana: "Próxima semana",
      mas15Dias: "15 días o más",
    })[value] || "";
  const renderEjecutivosOptions = () => {
    const countryMapping = { Uruguay: "URU", Perú: "PER", Chile: "CHI" };
    const countryCode = countryMapping[pais] || "";
    const ejecutivosUnicos = usuarios
      .filter((user) => {
        const userPais = user.pais || "";
        const userRol = user.rol ? user.rol.toLowerCase().trim() : "";
        const validRoles = ["comercial", "gerencia"].map((r) => r.toLowerCase());
        return (userPais === countryCode || !countryCode) && validRoles.includes(userRol) && user.habilitado === true;
      })
      .sort((a, b) => `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`));
    return ejecutivosUnicos.map((usuario, index) => (
      <option key={index} value={usuario.id}>
        {`${usuario.nombre} ${usuario.apellido}`}
      </option>
    ));
  };
  const getRadius = (key, data) => {
    const keys = Object.keys(data).filter((key) => data[key] > 0);
    const firstKey = keys[0];
    const lastKey = keys.at(-1);
    if (firstKey === key && lastKey === key) return [10, 10, 10, 10];
    else if (firstKey === key) return [10, 0, 0, 10];
    else if (lastKey === key) return [0, 10, 10, 0];
    return [0, 0, 0, 0];
  };
  const getBootstrapClassForStatus = (status) => {
    switch (status) {
      case "100%":
        return "bg-success";
      case "90%":
        return "bg-danger";
      case "75%":
        return "bg-primary";
      case "50%":
        return "bg-warning";
      case "0%":
        return "bg-black";
      default:
        return "bg-secondary";
    }
  };
  const getColorForStatus = (status) => {
    switch (status) {
      case "100%":
        return "#198754";
      case "90%":
        return "#dc3545";
      case "75%":
        return "#0d6efd";
      case "50%":
        return "#ffc107";
      case "0%":
        return "#000000";
      default:
        return "#555555";
    }
  };
  const getLabelColorForStatus = (status) => (status === "50%" ? "#000" : "#fff");
  useEffect(() => {
    const newData = [
      {
        name: "Total",
        "100%": (sumasFiltradas["100%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "90%": (sumasFiltradas["90%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "75%": (sumasFiltradas["75%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "50%": (sumasFiltradas["50%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        "0%": (sumasFiltradas["0%"] / (Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) || 1)) * 100 || 0,
        empty: Object.values(sumasFiltradas).reduce((a, b) => a + b, 0) === 0 ? 100 : 0,
      },
    ];
    setData(newData);
  }, [sumasFiltradas]);
  // Flash form state ahora se maneja dentro de FlashEditModal
  const parseLocalDate = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };
  const filtrarClientes = useCallback(() => {
    let filteredClientes = clientes.filter((cliente) => {
      const nombreAgencia = getIntermediarioNombre(cliente.agencia);
      const matchesAgencia =
        filtroIntermediario === "" ||
        nombreAgencia === filtroIntermediario ||
        (!filtroIntermediario.includes("|") && nombreAgencia.startsWith(`${filtroIntermediario} |`));
      const clienteMatch = !filtroCliente || cliente.empresa.toLowerCase().includes(filtroCliente.toLowerCase());
      const productoMatch = !filtroProducto || cliente.producto === filtroProducto;
      const categoriaClienteMatch =
        filtroCategoriaCliente.length === 0 || filtroCategoriaCliente.includes(cliente.categoria_cliente);
      const categoriaMatch =
        filtroCategoria === "" || (cliente.categoria && parseInt(cliente.categoria) === parseInt(filtroCategoria));
      const subcategoriaMatch =
        !filtroSubcategoria || String(cliente.subcategoria_id) === String(filtroSubcategoria);
      const mesMatch =
        filtroMes.length === 0 ||
        [...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
          (op) => op.client_id === cliente.id && filtroMes.includes(op.mes_factura?.split("-")?.[0] || "01")
        );
      const estatusMatch =
        filtroEstatus.length === 0 ||
        (filtroEstatus.includes("sinPropuesta") &&
          ![...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
            (op) =>
              op.client_id === cliente.id &&
              (op.estatus === "90%" ||
                op.estatus === "75%" ||
                op.estatus === "50%" ||
                (op.status < 100 && op.status > 0))
          )) ||
        [...todasLasOportunidades, ...todasLasOportunidadesBTL].some(
          (op) => op.client_id === cliente.id && filtroEstatus.includes(op.estatus || `${op.status}%`)
        );
      const proximoClienteText = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
      const proximoAgenciaText = getDaysDifference(cliente.proximo_contacto_fecha_agencia, true);
      const clienteProximoDate = parseLocalDate(cliente.proximo_contacto_fecha_cliente);
      const agenciaProximoDate = parseLocalDate(cliente.proximo_contacto_fecha_agencia);
      const matchesProximoContacto = (() => {
        if (!ordenamiento.porFecha || ordenamiento.porFecha === "null") return true;
        const ordenValue = ordenamiento.porFecha;
        const targetText = mapOrdenamientoToText(ordenValue);
        if (ordenValue === "estaSemana") {
          const isClienteEstaSemana =
            clienteProximoDate && clienteProximoDate >= startOfCurrentWeek && clienteProximoDate <= endOfCurrentWeek;
          const isAgenciaEstaSemana =
            agenciaProximoDate && agenciaProximoDate >= startOfCurrentWeek && agenciaProximoDate <= endOfCurrentWeek;
          return isClienteEstaSemana || isAgenciaEstaSemana;
        }
        if (ordenValue === "proximaSemana") {
          const isClienteProxSemana =
            clienteProximoDate && clienteProximoDate >= startOfNextWeek && clienteProximoDate <= endOfNextWeek;
          const isAgenciaProxSemana =
            agenciaProximoDate && agenciaProximoDate >= startOfNextWeek && agenciaProximoDate <= endOfNextWeek;
          return isClienteProxSemana || isAgenciaProxSemana;
        }
        return proximoClienteText === targetText || proximoAgenciaText === targetText;
      })();
      const usuarioMatch =
        !filtroUsuario ||
        [
          cliente.contacto_cliente,
          cliente.contacto_cliente_1,
          cliente.contacto_cliente_2,
          cliente.contacto_cliente_3,
          cliente.contacto_agencia,
          cliente.contacto_agencia_1,
          cliente.contacto_agencia_2,
          cliente.contacto_agencia_3,
        ].some((id) => String(id) === String(filtroUsuario));
      const matchesEjecutivo = !filtroEjecutivo || String(cliente.ejecutivo) === String(filtroEjecutivo);
      return (
        clienteMatch &&
        productoMatch &&
        categoriaMatch &&
        subcategoriaMatch &&
        categoriaClienteMatch &&
        matchesAgencia &&
        mesMatch &&
        estatusMatch &&
        matchesProximoContacto &&
        usuarioMatch &&
        matchesEjecutivo
      );
    });
    filteredClientes = filteredClientes.sort((a, b) => {
      const oportunidades90A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "90%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades90B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "90%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades90A !== oportunidades90B) return oportunidades90B - oportunidades90A;
      const oportunidades75A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "75%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades75B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "75%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades75A !== oportunidades75B) return oportunidades75B - oportunidades75A;
      const oportunidades50A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "50%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades50B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "50%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades50A !== oportunidades50B) return oportunidades50B - oportunidades50A;
      const oportunidades100A = ventasData.ventasPorCliente[a.id] || 0;
      const oportunidades100B = ventasData.ventasPorCliente[b.id] || 0;
      if (oportunidades100A !== oportunidades100B) return oportunidades100B - oportunidades100A;
      const oportunidades0A =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === a.id && op.estatus === "0%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      const oportunidades0B =
        [...todasLasOportunidades, ...todasLasOportunidadesBTL]
          .filter((op) => op.client_id === b.id && op.estatus === "0%")
          .reduce((sum, op) => sum + convertirParaSort(op), 0) || 0;
      if (oportunidades0A !== oportunidades0B) return oportunidades0B - oportunidades0A;
      const dateA =
        parseLocalDate(a.proximo_contacto_fecha_cliente) || parseLocalDate(a.proximo_contacto_fecha_agencia);
      const dateB =
        parseLocalDate(b.proximo_contacto_fecha_cliente) || parseLocalDate(b.proximo_contacto_fecha_agencia);
      if (dateA && dateB && dateA.getTime() !== dateB.getTime()) {
        const priorityA = getContactoPriority(
          a,
          today,
          todayDate,
          tomorrowDate,
          startOfCurrentWeek,
          endOfCurrentWeek,
          startOfNextWeek,
          endOfNextWeek,
          fifteenDaysFromNow
        );
        const priorityB = getContactoPriority(
          b,
          today,
          todayDate,
          tomorrowDate,
          startOfCurrentWeek,
          endOfCurrentWeek,
          startOfNextWeek,
          endOfNextWeek,
          fifteenDaysFromNow
        );
        if (priorityA !== priorityB) return priorityA - priorityB;
        return dateA - dateB;
      }
      return a.empresa.localeCompare(b.empresa);
    });
    return filteredClientes;
  }, [
    clientes,
    filtroCategoria,
    filtroCategoriaCliente,
    filtroCliente,
    filtroEstatus,
    filtroIntermediario,
    filtroMes,
    todasLasOportunidades,
    todasLasOportunidadesBTL,
    filtroUsuario,
    filtroEjecutivo,
    ordenamiento.porFecha,
    ventasData.ventasPorCliente,
    today,
    todayDate,
    tomorrowDate,
    startOfCurrentWeek,
    endOfCurrentWeek,
    startOfNextWeek,
    endOfNextWeek,
    fifteenDaysFromNow,
    mapOrdenamientoToText,
    getDaysDifference,
    getIntermediarioNombre,
    convertirParaSort,
    pais,
    getContactoPriority,
  ]);

  const filtersContent = (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", gap: "16px" }}>
      <div className={s.filtersContainer} style={{ flex: 1 }}>
        {/* Fila 1: Ejecutivo, Marca, Producto, Mes/meses, Status */}
        <div className={s.filterRow}>
          <div>
            <select
              className={`form-control ${filtroEjecutivo ? s.activeFilter : ""}`}
              value={filtroEjecutivo || ""}
              onChange={(e) => setFiltroEjecutivo(e.target.value)}
            >
              <option value="">Ejecutivo</option>
              {renderEjecutivosOptions()}
            </select>
          </div>
          <div>
            <select
              className={`form-control ${filtroCliente ? s.activeFilter : ""}`}
              value={filtroCliente || ""}
              onChange={(e) => setFiltroCliente(e.target.value)}
            >
              <option value="">Marca</option>
              {renderClientesOptions()}
            </select>
          </div>
          <div>
            <select
              className={`form-control ${filtroProducto ? s.activeFilter : ""}`}
              value={filtroProducto || ""}
              onChange={(e) => setFiltroProducto(e.target.value)}
              disabled={!filtroCliente || (filtroCliente && getProductosCount(filtroCliente) <= 1)}
            >
              <option value="">Producto</option>
              {renderProductosOptions()}
            </select>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-basic"
                className={`form-control text-start ${filtroMes.length > 0 ? s.activeFilter : ""}`}
              >
                {filtroMes.length > 0 ? filtroMes.map((mes) => mesEnLetras(mes)).join(", ") : "Mes/meses"}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderMesOptions()}</Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-status"
                className={`form-control text-start ${filtroEstatus.length > 0 ? s.activeFilter : ""}`}
              >
                {filtroEstatus.length > 0 ? filtroEstatus.join(", ") : "Status"}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderEstatusOptions()}</Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {/* Fila 2: Categoría, Intermediario, Próximo Contacto, Usuario, Tipo Cliente */}
        <div className={s.filterRow}>
          <CategoriaSubcategoriaFilter
            categorias={categorias}
            subcategorias={subcategorias}
            filtroCategoria={filtroCategoria}
            filtroSubcategoria={filtroSubcategoria}
            onCategoriaChange={setFiltroCategoria}
            onSubcategoriaChange={setFiltroSubcategoria}
            className="form-control"
            activeClass={s.activeFilter}
          />
          <div>
            <select
              className={`form-control ${filtroIntermediario ? s.activeFilter : ""}`}
              value={filtroIntermediario}
              onChange={(e) => setFiltroIntermediario(e.target.value)}
            >
              <option value="">Intermediario</option>
              {renderIntermediariosOptions()}
            </select>
          </div>
          <div>
            <select
              className={`form-control ${filtroUsuario ? s.activeFilter : ""}`}
              value={filtroUsuario || ""}
              onChange={(e) => setFiltroUsuario(e.target.value)}
            >
              <option value="">Usuario</option>
              {renderUsuariosOptions()}
            </select>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-categoria-cliente"
                className={`form-control text-start ${filtroCategoriaCliente.length > 0 ? s.activeFilter : ""}`}
              >
                {filtroCategoriaCliente.length > 0 ? filtroCategoriaCliente.join(", ") : "Tipo Cliente"}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderCategoriaClienteOptions()}</Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          whiteSpace: "nowrap",
          marginRight: "16px",
          cursor: "pointer",
          fontSize: "0.85rem",
          color: "#000",
        }}
      >
        Ver en dólares
        <input
          type="checkbox"
          checked={viewInUSD}
          onChange={(e) => setViewInUSD(e.target.checked)}
          disabled={!ratesLoaded}
        />
      </label>
    </div>
  );

  return (
    <div>
      {loading ? (
        <div>Cargando...</div>
      ) : (
        <>
          {renderHeader ? renderHeader(filtersContent) : filtersContent}
          <div className={`mb-2 ${styles.cardsContainer}`}>
            <div className="d-flex justify-content-between">
              <div
                className="text-center p-2 border border-dark m-3 text-white"
                style={{ borderRadius: "5px", width: "200px", backgroundColor: "#6318a9ff" }}
              >
                <div>
                  <strong>Cierres {CURRENT_YEAR}</strong>
                </div>
                <div>{sumCierres > 0 ? formatMoneda(sumCierres, viewInUSD) : "-"}</div>
              </div>
              {["100%", "90%", "75%", "50%", "0%"].map((estatus, index) => (
                <div
                  key={index}
                  className={`text-center p-2 ${getBootstrapClassForStatus(estatus)} border border-dark m-3 text-${
                    estatus === "50%" ? "dark" : "white"
                  }`}
                  style={{ borderRadius: "5px", width: "200px" }}
                >
                  <div>
                    <strong>{estatus === "100%" ? `Facturación ${CURRENT_YEAR}` : estatus}</strong>
                  </div>
                  <div>{sumasFiltradas[estatus] > 0 ? formatMoneda(sumasFiltradas[estatus], viewInUSD) : "-"}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.chartContainer}>
            <ResponsiveContainer width="100%" height={80} className="p-0 m-0">
              <BarChart layout="vertical" data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                <XAxis type="number" domain={[0, 100]} tick={false} axisLine={false} />
                <YAxis type="category" dataKey="name" hide />
                {data[0].empty > 0 ? (
                  <Bar dataKey="empty" fill="#555555" isAnimationActive={false} radius={[10, 10, 10, 10]}>
                    <LabelList
                      dataKey="empty"
                      position="center"
                      formatter={() => "Sin propuestas asociadas :("}
                      fill="#FFF"
                    />
                  </Bar>
                ) : (
                  ["100%", "90%", "75%", "50%", "0%"].map(
                    (estatus) =>
                      data[0][estatus] > 0 && (
                        <Bar
                          key={estatus}
                          dataKey={estatus}
                          stackId="a"
                          fill={getColorForStatus(estatus)}
                          radius={getRadius(estatus, data[0])}
                        >
                          <LabelList
                            dataKey={estatus}
                            position="center"
                            formatter={(value) => `${Math.round(value)}%`}
                            fill={getLabelColorForStatus(estatus)}
                          />
                        </Bar>
                      )
                  )
                )}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <table id="ventas-table" className={`${styles.ventasTable} table table-bordered`}>
            <thead>
              <tr>
                <th rowSpan={2} className="text-center col-cliente">{toUpperCase("CLIENTE/PROSPECT")}</th>
                <th rowSpan={2} className="text-center col-ejecutivos">{toUpperCase("EJECUTIVOS ASIGNADOS")}</th>
                <th rowSpan={2} className="text-center col-oportunidad">{toUpperCase("OPORTUNIDADES")}</th>
                <th rowSpan={2} className="text-center col-contacto">{toUpperCase("CONTACTO")}</th>
                <th rowSpan={2} className="text-center col-actividad">
                  {toUpperCase("ACTIVIDAD RECIENTE")}
                </th>
                {/* OCULTO: PRÓXIMO CONTACTO
                <th rowSpan={2} colSpan="2" className="text-center col-proximo">
                  {toUpperCase("PRÓXIMO CONTACTO")}
                </th>
                */}
                {/* OCULTO: EDIT
                <th rowSpan={2} className="text-center col-edit">{toUpperCase("EDIT")}</th>
                */}
                {/* OCULTO: TIPO - el filtro sigue funcional */}
                <th rowSpan={2} className="text-center col-tipo" style={{ display: "none" }}>{toUpperCase("TIPO")}</th>
                <th colSpan="3" className="text-center col-importes status-100">{toUpperCase("Facturación")}</th>
              </tr>
              <tr>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>{toUpperCase("YTD")}</th>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>{toUpperCase("AA")}</th>
                <th className="text-center" style={{ fontSize: "0.85rem" }}>{toUpperCase("HTD")}</th>
              </tr>
            </thead>
            {filtrarClientes().length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan="12" className="text-center">
                    No hay data según los filtros seleccionados :(
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {filtrarClientes().map((cliente, index) => {
                  const isOdd = index % 2 === 0;
                  const agenciaContacts = sortContacts(
                    [
                      cliente.contacto_agencia,
                      cliente.contacto_agencia_1,
                      cliente.contacto_agencia_2,
                      cliente.contacto_agencia_3,
                    ],
                    usuarios,
                    "agencia",
                    ["Director de cuenta", "Supervisor de cuenta", "Planificador", "Asistente"]
                  );
                  const clienteContacts = sortContacts(
                    [
                      cliente.contacto_cliente,
                      cliente.contacto_cliente_1,
                      cliente.contacto_cliente_2,
                      cliente.contacto_cliente_3,
                    ],
                    usuarios,
                    "cliente",
                    [
                      "Director de marketing",
                      "Gerente de marketing",
                      "Subgerente de marketing",
                      "Brand manager",
                      "Jefe de medios",
                      "Asistente de marketing",
                    ]
                  );
                  const ventasMoneda = todasLasOportunidades
                    .filter((op) => op.client_id === cliente.id && op.estatus === "100%")
                    .every((op) => op.moneda_dolar)
                    ? "US$"
                    : getMonedaSymbol();
                  return (
                    <React.Fragment key={`pair-${index}`}>
                      <tr
                        className={isOdd ? styles.oddPair : styles.evenPair}
                        data-pair-index={index}
                        data-bg={isOdd ? "odd" : "even"}
                      >
                        <td
                          className="text-start"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}
                        >
                          <strong style={{ fontSize: "1.1rem" }}>{toUpperCase(cliente.empresa)}</strong>
                          <br />
                          {cliente.empresa !== cliente.producto && (
                            <>
                              <span style={{ fontSize: "1.0rem" }}>{toUpperCase(cliente.producto || "")}</span>
                              <br />
                            </>
                          )}
                          {(() => {
                            const clientOpportunities = [...todasLasOportunidades, ...todasLasOportunidadesBTL]
                              .filter(
                                (op) =>
                                  op.client_id === cliente.id &&
                                  (op.estatus === "90%" ||
                                    op.estatus === "75%" ||
                                    op.estatus === "50%" ||
                                    (op.status < 100 && op.status > 0))
                              )
                              .sort((a, b) => {
                                const priority = { "90%": 0, "75%": 1, "50%": 2 };
                                const priA = priority[a.estatus || `${a.status}%`] ?? 3;
                                const priB = priority[b.estatus || `${b.status}%`] ?? 3;
                                if (priA !== priB) return priA - priB;
                                const importeA = convertirParaSort(a);
                                const importeB = convertirParaSort(b);
                                return importeB - importeA;
                              });
                            return clientOpportunities.length > 0 ? (
                              <span style={{ fontSize: "0.85rem" }}>
                                {toUpperCase(clientOpportunities[0].campana || "")}
                              </span>
                            ) : (
                              <span style={{ fontSize: "0.85rem" }} />
                            );
                          })()}
                        </td>
                        <td
                          className="text-start"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}
                        >
                          {(() => {
                            const ejecutivos =
                              cliente.ejecutivos_asignados?.length > 0
                                ? cliente.ejecutivos_asignados
                                : [cliente.ejecutivo];
                            const ejecutivosUsuarios = sortContacts(
                              ejecutivos.filter((id) => id && usuarios.find((user) => String(user.id) === String(id))),
                              usuarios,
                              "ejecutivo",
                              ["Gerente", "Comercial", "Asistente"]
                            );
                            return ejecutivosUsuarios.length > 0 ? (
                              ejecutivosUsuarios.map((user, idx) => (
                                <div key={`${cliente.id}-ejecutivo-${idx}`} style={{ marginBottom: "2px" }}>
                                  {`${user.nombre} ${user.apellido}`}
                                </div>
                              ))
                            ) : (
                              <div>-</div>
                            );
                          })()}
                        </td>
                        <td
                          className="text-end"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", position: "relative" }}
                        >
                          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            {(() => {
                              const clientOpportunities = [...todasLasOportunidades, ...todasLasOportunidadesBTL]
                                .filter(
                                  (op) =>
                                    op.client_id === cliente.id &&
                                    (op.estatus === "90%" ||
                                      op.estatus === "75%" ||
                                      op.estatus === "50%" ||
                                      (op.status < 100 && op.status > 0))
                                )
                                .sort((a, b) => {
                                  const priority = { "90%": 0, "75%": 1, "50%": 2 };
                                  const priA = priority[a.estatus || `${a.status}%`] ?? 3;
                                  const priB = priority[b.estatus || `${b.status}%`] ?? 3;
                                  if (priA !== priB) return priA - priB;
                                  const importeA = convertirParaSort(a);
                                  const importeB = convertirParaSort(b);
                                  return importeB - importeA;
                                });
                              return clientOpportunities.length > 0
                                ? clientOpportunities.map((oportunidad, index) => (
                                  <React.Fragment key={`oportunidad-${cliente.id}-${oportunidad.id}`}>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        gap: "2px",
                                      }}
                                    >
                                      <span
                                        className={styles.badgeOportunidad}
                                        style={{
                                          color: getColorForStatus(oportunidad.estatus || `${oportunidad.status}%`),
                                        }}
                                      >
                                        {viewInUSD
                                          ? formatMoneda(
                                            getImporteEnUSD(oportunidad, getDolarValue, fallbackRate),
                                            true
                                          )
                                          : formatMoneda(
                                            oportunidad.importe || oportunidad.total_investment,
                                            oportunidad.moneda_dolar
                                          )}
                                      </span>
                                      {(() => {
                                        const dateInfo = getOportunidadDateStatus(oportunidad);
                                        if (dateInfo.isActive) {
                                          return (
                                            <div className={styles.dateInfoBlock}>
                                              {dateInfo.hasUpdate && dateInfo.daysSinceUpdate != null && (
                                                <div
                                                  className={`${styles.updateInfo} ${styles[`updateInfo_${dateInfo.severity}`] || ""}`}
                                                >
                                                  {dateInfo.daysSinceUpdate === 0
                                                    ? "Update: hoy"
                                                    : `Update: ${dateInfo.daysSinceUpdate} día${dateInfo.daysSinceUpdate > 1 ? "s" : ""}`}
                                                </div>
                                              )}
                                              {dateInfo.daysSinceCreated != null && (
                                                <div className={styles.createdInfo}>
                                                  {dateInfo.daysSinceCreated === 0
                                                    ? "Creada: hoy"
                                                    : `Creada: ${dateInfo.daysSinceCreated} día${dateInfo.daysSinceCreated > 1 ? "s" : ""}`}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }
                                        return (
                                          <div className={styles.dateInfoBlock}>
                                            {dateInfo.createdLabel && (
                                              <div className={styles.createdInfo}>
                                                Creada {dateInfo.createdLabel}
                                              </div>
                                            )}
                                            {dateInfo.updatedLabel
                                              && dateInfo.updatedLabel !== dateInfo.createdLabel && (
                                              <div className={styles.createdInfo}>
                                                Cerrada {dateInfo.updatedLabel}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })()}
                                      {(rol === "superadmin" ||
                                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                                          (rol === "gerencia" &&
                                            (cliente.ejecutivos_asignados?.includes(Number(id)) ||
                                              String(id) === String(cliente.ejecutivo))) ||
                                          (rol === "comercial" &&
                                            (cliente.ejecutivos_asignados?.includes(Number(id)) ||
                                              String(id) === String(cliente.ejecutivo)))) && (
                                        <div style={{ display: "flex", gap: "5px" }}>
                                          <TiFlash
                                            style={{ cursor: "pointer", fontSize: "1rem", color: "#555" }}
                                            onClick={() => handleFlashEdit(oportunidad)}
                                          />
                                          <FaEdit
                                            style={{ cursor: "pointer", fontSize: "1rem", color: "#555" }}
                                            onClick={() => handleEdit(oportunidad)}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {index < clientOpportunities.length - 1 && clientOpportunities.length >= 2 && (
                                      <hr
                                        style={{
                                          width: "95%",
                                          margin: "5px 1px auto",
                                          borderTop: "1px solid #999",
                                          opacity: 0.5,
                                        }}
                                      />
                                    )}
                                  </React.Fragment>
                                ))
                                : "-";
                            })()}
                          </div>
                        </td>
                        <td
                          className="text-start"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "top" }}
                        >
                          {cliente.agencia && !AGENCIAS_DIRECTAS.includes(Number(cliente.agencia)) ? (
                            <>
                              <div className="fw-bold">{getIntermediarioNombre(cliente.agencia)}</div>
                              {agenciaContacts.length > 0 ? (
                                agenciaContacts.map((user, idx) => (
                                  <div key={`${cliente.id}-agencia-${idx}`} style={{ marginBottom: "2px", paddingLeft: "10px" }}>
                                    {`${user.nombre} ${user.apellido}`}
                                  </div>
                                ))
                              ) : (
                                <div style={{ paddingLeft: "10px", color: "#666", fontStyle: "italic" }}>
                                  Sin contactos de agencia
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="fw-bold text-success">Trato directo</div>
                          )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          <ActividadesRecientes
                            actividades={actividadesCRM[cliente.id] || []}
                            usuarios={usuarios}
                            tipoFiltro="agencia"
                            maxItems={5}
                            loading={loadingCRM}
                            contactIds={[
                              cliente.contacto_agencia,
                              cliente.contacto_agencia_1,
                              cliente.contacto_agencia_2,
                              cliente.contacto_agencia_3,
                            ]}
                          />
                        </td>
                        {/* OCULTO: PRÓXIMO CONTACTO AGENCIA
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editProximoContacto}>
                                  <DatePicker
                                    selected={proximo_contacto_fecha_agencia}
                                    onChange={(date) => setProximoContactoFechaAgencia(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    minDate={new Date()}
                                    maxDate={() => {
                                      const maxDate = new Date();
                                      maxDate.setMonth(maxDate.getMonth() + 3);
                                      return maxDate;
                                    }}
                                    startDate={new Date()}
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6;
                                    }}
                                    monthsShown={3}
                                  />
                                </div>
                              ) : cliente.proximo_contacto_fecha_agencia ? (
                                (() => {
                                  const text = getDaysDifference(cliente.proximo_contacto_fecha_agencia, true);
                                  const status = getStatusFromText(text, true);
                                  return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                })()
                              ) : (
                                "-"
                              )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {editingAgenciaContact === cliente.id &&
                          (rol === "superadmin" || rol === "gerencia" || rol === "comercial") ? (
                                <div className={styles.editProximoContacto}>
                                  <select
                                    value={proximo_contacto_accion_agencia}
                                    className={styles.smallInput}
                                    onChange={(e) => setProximoContactoAccionAgencia(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                </div>
                              ) : (
                                toUpperCase(cliente.proximo_contacto_accion_agencia || "-")
                              )}
                        </td>
                        */}
                        {/* OCULTO: EDIT AGENCIA
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" &&
                            (String(id) === String(cliente.ejecutivo) ||
                              cliente.ejecutivos_asignados?.includes(Number(id)))) ||
                          rol === "comercial" ? (
                                !editingAgenciaContact ? (
                                  <FaEdit
                                    onClick={() => {
                                      setEditingClienteId(cliente.id);
                                      setEditingAgenciaContact(cliente.id);
                                      setUltimoContactoFechaAgencia(
                                        cliente.ultimo_contacto_fecha_agencia
                                          ? parseLocalDate(cliente.ultimo_contacto_fecha_agencia)
                                          : null
                                      );
                                      setUltimoContactoAccionAgencia(cliente.ultimo_contacto_accion_agencia || "");
                                      setProximoContactoFechaAgencia(
                                        cliente.proximo_contacto_fecha_agencia
                                          ? parseLocalDate(cliente.proximo_contacto_fecha_agencia)
                                          : null
                                      );
                                      setProximoContactoAccionAgencia(cliente.proximo_contacto_accion_agencia || "");
                                    }}
                                  />
                                ) : editingAgenciaContact === cliente.id ? (
                                  <FiSave
                                    onClick={() =>
                                      handleUpdateCliente(
                                        cliente.id,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        null,
                                        ultimo_contacto_fecha_agencia,
                                        ultimo_contacto_accion_agencia,
                                        proximo_contacto_fecha_agencia,
                                        proximo_contacto_accion_agencia,
                                        cliente.contacto_cliente,
                                        cliente.contacto_agencia,
                                        tipoCliente
                                      )
                                        .then(() => {
                                          setEditingAgenciaContact(null);
                                          toast.success("Datos guardados exitosamente");
                                        })
                                        .catch((error) => {
                                          console.error("Error al guardar:", error);
                                          toast.error("Error al guardar los datos");
                                        })
                                    }
                                  />
                                ) : (
                                  "-"
                                )
                              ) : (
                                "-"
                              )}
                        </td>
                        */}
                        {/* OCULTO: TIPO - el filtro sigue funcional */}
                        <td
                          className="text-center"
                          rowSpan="2"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", display: "none" }}
                        >
                          {toUpperCase(cliente.categoria_cliente || "-")}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasYTD[cliente.id] !== undefined &&
  ventasData.ventasYTD[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasYTD[cliente.id], viewInUSD || ventasMoneda === "US$")
                            : "-"}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasAA[cliente.id] !== undefined &&
  ventasData.ventasAA[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasAA[cliente.id], viewInUSD || ventasMoneda === "US$")
                            : "-"}
                        </td>
                        <td rowSpan={2} className="text-end" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {ventasData.ventasHTD[cliente.id] !== undefined &&
  ventasData.ventasHTD[cliente.id] !== 0
                            ? formatMoneda(ventasData.ventasHTD[cliente.id], viewInUSD || ventasMoneda === "US$")
                            : "-"}
                        </td>
                      </tr>
                      <tr
                        className={isOdd ? styles.oddPair : styles.evenPair}
                        data-pair-index={index}
                        data-bg={isOdd ? "odd" : "even"}
                      >
                        <td
                          className="text-start"
                          style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff", verticalAlign: "top" }}
                        >
                          <div className="fw-bold">Cliente</div>
                          {clienteContacts.length > 0 ? (
                            clienteContacts.map((user, idx) => (
                              <div key={`${cliente.id}-cliente-${idx}`} style={{ marginBottom: "2px", paddingLeft: "10px" }}>
                                {`${user.nombre} ${user.apellido}`}
                              </div>
                            ))
                          ) : (
                            <div style={{ paddingLeft: "10px", color: "#dc3545", fontStyle: "italic", fontWeight: "bold" }}>
                              Sin contactos del cliente
                            </div>
                          )}
                        </td>
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          <ActividadesRecientes
                            actividades={actividadesCRM[cliente.id] || []}
                            usuarios={usuarios}
                            tipoFiltro="cliente"
                            maxItems={5}
                            loading={loadingCRM}
                            contactIds={[
                              cliente.contacto_cliente,
                              cliente.contacto_cliente_1,
                              cliente.contacto_cliente_2,
                              cliente.contacto_cliente_3,
                            ]}
                          />
                        </td>
                        {/* OCULTO: PRÓXIMO CONTACTO CLIENTE
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  cliente.proximo_contacto_fecha_cliente ? (
                                    (() => {
                                      const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                      const status = getStatusFromText(text, true);
                                      return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                    })()
                                  ) : (
                                    "-"
                                  )
                                ) : editingClienteContact === cliente.id ? (
                                  <DatePicker
                                    selected={proximo_contacto_fecha_cliente}
                                    onChange={(date) => setProximoContactoFechaCliente(date)}
                                    dateFormat="dd MMM"
                                    className={styles.smallInput}
                                    calendarStartDay={1}
                                    minDate={new Date()}
                                    maxDate={() => {
                                      const maxDate = new Date();
                                      maxDate.setMonth(maxDate.getMonth() + 3);
                                      return maxDate;
                                    }}
                                    startDate={new Date()}
                                    filterDate={(date) => {
                                      const day = date.getDay();
                                      return day !== 0 && day !== 6;
                                    }}
                                    monthsShown={3}
                                  />
                                ) : cliente.proximo_contacto_fecha_cliente ? (
                                  (() => {
                                    const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                    const status = getStatusFromText(text, true);
                                    return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                  })()
                                ) : (
                                  "-"
                                )
                              ) : cliente.proximo_contacto_fecha_cliente ? (
                                (() => {
                                  const text = getDaysDifference(cliente.proximo_contacto_fecha_cliente, true);
                                  const status = getStatusFromText(text, true);
                                  return <span className={`${styles.contactoStatus} ${styles[status]}`}>{text}</span>;
                                })()
                              ) : (
                                "-"
                              )}
                        </td>
                        <td style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" && String(id) === String(cliente.ejecutivo)) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                                ) : editingClienteContact === cliente.id ? (
                                  <select
                                    value={proximo_contacto_accion_cliente}
                                    className={styles.smallInput}
                                    onChange={(e) => setProximoContactoAccionCliente(e.target.value)}
                                  >
                                    <option value="">Seleccionar</option>
                                    <option value="RRSS">{toUpperCase("RRSS")}</option>
                                    <option value="CALL">{toUpperCase("CALL")}</option>
                                    <option value="MAIL">{toUpperCase("MAIL")}</option>
                                    <option value="MEET">{toUpperCase("MEET")}</option>
                                    <option value="QUOTE">{toUpperCase("QUOTE")}</option>
                                    <option value="FOLLOW UP">{toUpperCase("FOLLOW UP")}</option>
                                    <option value="SALE!">{toUpperCase("SALE!")}</option>
                                  </select>
                                ) : (
                                  toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                                )
                              ) : (
                                toUpperCase(cliente.proximo_contacto_accion_cliente || "-")
                              )}
                        </td>
                        */}
                        {/* OCULTO: EDIT CLIENTE
                        <td className="text-center" style={{ backgroundColor: isOdd ? "#e0e0e0" : "#ffffff" }}>
                          {rol === "superadmin" ||
                          (pais === "Perú" && (rol === "gerencia" || rol === "comercial")) ||
                          (rol === "gerencia" &&
                            (String(id) === String(cliente.ejecutivo) ||
                              cliente.ejecutivos_asignados?.includes(Number(id)))) ||
                          rol === "comercial" ? (
                                !editingClienteContact ? (
                                  <FaEdit
                                    onClick={() => {
                                      setEditingClienteId(cliente.id);
                                      setEditingClienteContact(cliente.id);
                                      setUltimoContactoFechaCliente(
                                        cliente.ultimo_contacto_fecha_cliente
                                          ? parseLocalDate(cliente.ultimo_contacto_fecha_cliente)
                                          : null
                                      );
                                      setUltimoContactoAccionCliente(cliente.ultimo_contacto_accion_cliente || "");
                                      setProximoContactoFechaCliente(
                                        cliente.proximo_contacto_fecha_cliente
                                          ? parseLocalDate(cliente.proximo_contacto_fecha_cliente)
                                          : null
                                      );
                                      setProximoContactoAccionCliente(cliente.proximo_contacto_accion_cliente || "");
                                    }}
                                  />
                                ) : editingClienteContact === cliente.id ? (
                                  <FiSave
                                    onClick={() =>
                                      handleUpdateCliente(
                                        cliente.id,
                                        cliente.ejecutivo,
                                        cliente.agencia,
                                        ultimo_contacto_fecha_cliente,
                                        ultimo_contacto_accion_cliente,
                                        proximo_contacto_fecha_cliente,
                                        proximo_contacto_accion_cliente,
                                        null,
                                        null,
                                        null,
                                        null,
                                        cliente.contacto_cliente,
                                        cliente.contacto_agencia,
                                        tipoCliente
                                      )
                                        .then(() => {
                                          setEditingClienteContact(null);
                                          toast.success("Datos guardados exitosamente");
                                        })
                                        .catch((error) => {
                                          console.error("Error al guardar:", error);
                                          toast.error("Error al guardar los datos");
                                        })
                                    }
                                  />
                                ) : (
                                  "-"
                                )
                              ) : (
                                "-"
                              )}
                        </td>
                        */}
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            )}
          </table>
          {isModalOpen && (
            <div
              className="modal"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "5px",
                  minWidth: "200px",
                  textAlign: "center",
                }}
              >
                <h5>Cambiar estatus de oportunidad</h5>
                <div style={{ marginTop: "15px" }}>
                  {selectedOportunidadId && (
                    <div>
                      {todasLasOportunidades.find((op) => op.id === selectedOportunidadId && op.estatus === "90%") && (
                        <>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("100%"),
                              color: getLabelColorForStatus("100%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "100%");
                              setIsModalOpen(false);
                            }}
                          >
                            100%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("75%"),
                              color: getLabelColorForStatus("75%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "75%");
                              setIsModalOpen(false);
                            }}
                          >
                            75%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("50%"),
                              color: getLabelColorForStatus("50%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "50%");
                              setIsModalOpen(false);
                            }}
                          >
                            50%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("0%"),
                              color: getLabelColorForStatus("0%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "0%");
                              setIsModalOpen(false);
                            }}
                          >
                            0%
                          </button>
                        </>
                      )}
                      {todasLasOportunidades.find((op) => op.id === selectedOportunidadId && op.estatus === "75%") && (
                        <>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("100%"),
                              color: getLabelColorForStatus("100%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "100%");
                              setIsModalOpen(false);
                            }}
                          >
                            100%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("90%"),
                              color: getLabelColorForStatus("90%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "90%");
                              setIsModalOpen(false);
                            }}
                          >
                            90%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("50%"),
                              color: getLabelColorForStatus("50%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "50%");
                              setIsModalOpen(false);
                            }}
                          >
                            50%
                          </button>
                          <button
                            style={{
                              margin: "5px",
                              padding: "5px 10px",
                              backgroundColor: getColorForStatus("0%"),
                              color: getLabelColorForStatus("0%"),
                              border: "none",
                              borderRadius: "3px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleUpdateStatus(selectedClienteId, selectedOportunidadId, "0%");
                              setIsModalOpen(false);
                            }}
                          >
                            0%
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
                <button
                  style={{
                    marginTop: "15px",
                    padding: "5px 10px",
                    backgroundColor: "grey",
                    color: "white",
                    border: "none",
                    borderRadius: "3px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}
          <FlashEditModal
            isOpen={isFlashEditing}
            onClose={() => {
              setIsFlashEditing(false);
              setFlashEditingOpportunity(null);
            }}
            opportunity={flashEditingOpportunity}
            onSave={onSubmitFlashEdit}
            saving={flashSaving}
            hideFacturacion={flashEditingOpportunity?.esContrato}
          />
        </>
      )}
    </div>
  );
};
